import React, { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import filterImages from "../utils/filterImages";

export default function ListPictures({ pictures = [] }) {
  // 🔹 Filtrer et supprimer les doublons comme dans le slider
  const filteredPictures = useMemo(() => filterImages(pictures), [pictures]);

  return (
    <ul className="w-auto h-auto flex flex-wrap justify-center">
      {filteredPictures.map((item) => (
        <li
          className="w-[90%] sm:w-[600px] h-auto p-0 m-[10px] rounded-[5px] shadow overflow-hidden"
          key={uuidv4()}
        >
          <img
            className="object-cover w-full h-full"
            src={item}
            alt="project details"
          />
        </li>
      ))}
    </ul>
  );
}
